// Phone numbers are stored in display format ("+355 69 205 5470"), but a tel:
// URI must not contain spaces — strip them at the point of use.
export const telHref = (number) => `tel:${String(number).replace(/\s/g, '')}`;
